import McException404 from './McException404';

export default McException404;
